import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=2ad7f8b8&scoped=true&"
import script from "./userMenu.vue?vue&type=script&lang=ts&"
export * from "./userMenu.vue?vue&type=script&lang=ts&"
import style0 from "./userMenu.vue?vue&type=style&index=0&id=2ad7f8b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7f8b8",
  null
  
)

export default component.exports